<section class="" [ngClass]="{'loginSection': !isShowAuthenticator}">
    <div class="login mt-5" *ngIf="!isShowAuthenticator">
        <div *ngIf="!isGoogleAuthenticatorRegistered">
            <div class="logo-container">
                <img  [src]="imageURL | async" alt="Active Image">
            </div>
            <div class="text-center mt-5 mb-3">
                <h6>{{welcomeMsg | async}}</h6>
            </div>

            <form class="form" [formGroup]="loginForm">
                <div class="col-xs-12 col-sm-12 col-md-12 ">
                    <div class="form-group mb-3">
                        <input type="text" formControlName="username" placeholder="Email ID"
                            [ngClass]="{ 'is-invalid': submitted && control['username'].errors }" class="form-control"
                            autocomplete="off">
                        <div *ngIf="control['username'].errors && submitted" class="small">
                            <div *ngIf="control['username'].errors['required']" class="text-danger letterspacing">
                                {{'user_email_is_required'|translate}} </div>
                            <div *ngIf="control['username'].errors['pattern']" class="text-danger letterspacing">
                                {{'INVALID_EMAIL'|translate}} </div>
                        </div>
                    </div>

                    <div class="form-group mt-2">
                        <input type="password" class="form-control" placeholder="Password" formControlName="password"
                            autocomplete="new-password"
                            [ngClass]="{ 'is-invalid': submitted && control['password'].errors }">
                        <div *ngIf="control['password'].errors && submitted" class="small">
                            <div *ngIf="control['password'].errors['required']" class="text-danger letterspacing">
                                {{'user_password_is_required'|translate}} </div>
                        </div>
                    </div>
                    <div class="form-group mt-2 text-end">
                        <a [routerLink]="['/auth/forgot_password']" class="font_size15px">{{'forgot_password'
                            | translate}}</a>
                    </div>
                    <div class="text-center mt-3">
                        <button class="btn btnc  me-1" (click)="login()"><em class="fa fa-fw fa-sign-in"></em> {{
                            'Login' | translate }}</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
    <app-authenticator *ngIf="submitted && isShowAuthenticator" [barcodeImageUrl]="barcodeImageUrl"
        [isGoogleAuthenticatorRegistered]="isGoogleAuthenticatorRegistered"
        [otpPromptMessage]="otpPromptMessage"
        [authenticationUniqueCode]="authenticationUniqueCode" [otpValue]="otp"
        [getuserAuthentication]="getuserAuthentication"></app-authenticator>
</section>